import React, { useState } from 'react'
import './RequestPayoutModal.css' // Optional: for styling
import ClipLoader from 'react-spinners/ClipLoader'

const FullPayoutModal = ({
  isOpen,
  onClose,
  onConfirm,
  payOutFee,
  isSponsorship,
  netPayout,
  payOutType,
  clipLoading,
  confirmBtn,
  disabledBtn,
  source,
}) => {
  const [amount, setAmount] = useState('')
  if (!isOpen) return null

  const handleSubmit = () => {
    const numericAmount = payOutType === 'full' ? netPayout : parseFloat(amount)

    onConfirm(numericAmount)
  }

  let requestAmount = payOutType === 'full' ? netPayout : parseFloat(amount)

  if (isNaN(requestAmount)) {
    requestAmount = 0 // or any sensible default
  }
  const payoutFee = payOutFee
  const amountReceive =
    amount > Number(netPayout)
      ? Number(netPayout - payoutFee).toFixed(2)
      : Number(requestAmount - payoutFee).toFixed(2)

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className={clipLoading ? 'd-none' : ''}>
          <label>
            <h5>Confirm {payOutType} payout</h5>
          </label>
          <p>You're about to request a {payOutType} payout for this event.</p>

          <div className="net-payout">
            <strong>Enter amount</strong> <span>R{Number(netPayout)}</span>
          </div>

          <div>
            <label className={requestAmount < 100 ? 'd-none' : 'w-100'}>
              Requested: R
              {amount > Number(netPayout) ? Number(netPayout) : Number(requestAmount).toFixed(2)}
              <br />
              Payout fee: R{Number(payoutFee).toFixed(2)}
              <br />
              <span className="font-normal">You will receive: R{amountReceive}</span>
              <br />
              <span className="font-normal">
                Balance after payout: R
                {amount > Number(netPayout)
                  ? Number(netPayout - netPayout).toFixed(2)
                  : Number(netPayout - requestAmount).toFixed(2)}
              </span>
              <br />
            </label>
            <input
              className="form-control"
              max={Number(netPayout)}
              placeholder={`Amount may not exceed R${
                source === 'partnerPayout' ? Number(netPayout).toFixed(2) : Number(netPayout)
              }`}
              type="text"
              readOnly={payOutType === 'full' ? true : false}
              value={
                payOutType === 'partial'
                  ? amount
                  : source === 'partnerPayout'
                  ? Number(netPayout)
                  : Number(netPayout)
              }
              onChange={(e) => setAmount(e.target.value)}
            />
            <label
              className={
                amount > Number(netPayout) ? 'w-100 alert alert-danger p-2 mt-2 mb-0' : 'd-none'
              }
            >
              You can't request more than your available balance. Please adjust the amount.
            </label>
          </div>

          <p className={payOutType === 'partial' ? 'd-none' : 'note'}>
            {/* {source === 'partnerPayout'
              ? 'Eligible Earnings reflect revenue from ticket sales tied to events with locked refund policies. If refunds were allowed and any linked transactions are refunded, this amount may be adjusted to maintain payout integrity.'
              : 'This amount reflects your full earnings after all applicable deductions. Booking fees are buyer-funded and do not reduce your payout.'
            } */}

            {source === 'partnerPayout' ? (
              <div className="alert alert-info mt-2 p-2" role="alert">
                Affiliate Earnings reflect commissions from ticket sales, regardless of refund
                policies. Even if refunds are processed for linked transactions, your affiliate
                payouts remain unchanged to ensure consistency and trust.
              </div>
            ) : (
              <div className="alert alert-info mt-2 p-2" role="alert">
                This amount reflects your full earnings after all applicable deductions. Booking
                fees are buyer-funded and do not reduce your payout.
              </div>
            )}
          </p>

          <div className="modal-actions">
            <button
              className={amount > Number(netPayout) ? 'd-none' : confirmBtn}
              onClick={handleSubmit}
              disabled={disabledBtn}
            >
              Confirm Payout
            </button>
            <button className="cancel-btn" onClick={onClose}>
              Cancel
            </button>
          </div>
        </div>
        <div className={!clipLoading ? 'd-none' : 'text-center text-grey'}>
          <ClipLoader size={25} color="grey" />
          <br />
          Submitting request...
        </div>
      </div>
    </div>
  )
}

export default FullPayoutModal
